import { DataTableField } from './DataTableField';
import { FieldEnum } from './FieldEnum';

export class DataTableSetting {

  public static init(sortBy: string,
                     sortDirection: string,
                     fields: DataTableField[],
                     items: any[] | Function,
                     showCheckbox?: boolean,
                     isRowClickSelected?: boolean): DataTableSetting {
    const setting = new DataTableSetting({
      sortBy,
      sortDirection,
      fields,
      items,
      isRowClickSelected,
    });
    if (showCheckbox) {
      setting.fields.unshift({
        key: 'checkbox',
        label: 'checkbox',
        type: FieldEnum.FIELD_CHECKBOX,
        sortable: false,
        thClass: 'checkbox-header',
      });
    }
    return setting;
  }
  public sortBy: string = '';
  public sortDesc: boolean = false;
  public sortDirection: string = 'asc';
  public items: any = [];
  public fields: DataTableField[] = [];
  public totalRows: number = 0;
  public currentPage: number = 1;
  public perPage: number = 10;
  public pageOptions: number[] = [5, 10, 15, 20, 30, 50];
  public filter: string = '';
  public isBusy: boolean = false;
  public showCheckbox?: boolean = false;
  public isRowClickSelected?: boolean = false;
  public rowClickFunction?: Function | null = null;
  public selected: string[] = [];

  constructor(init?: Partial<DataTableSetting>) {
    Object.assign(this, init);
    if (this.fields[0] && this.sortBy === '') {
      this.sortBy = this.fields[0].key;
    }
  }
}
